import { Stack, Typography } from "@mui/material"
import { useParams } from "react-router-dom"
import { useEffect } from "react"
import Hosts, { payUrl } from "../../../core/functions/HostFunctions"

const AffiliatedIntermediaryRedirectPage = () => {
  const { codeId } = useParams<{ codeId?: string }>()

  useEffect(() => {
    const redirectUrl = `${payUrl}/${codeId}/affiliated${window.location.search}`
    Hosts.redirect(redirectUrl)
  }, [])

  return (
    <Stack
      direction={"column"}
      width={"100%"}
      sx={{ p: 3 }}
      spacing={3}
      alignItems="center"
      justifyContent="center"
    >
      <Stack direction="column" alignItems="center">
        <Typography variant="body1" fontWeight={500} textAlign="center">
          Carregando...
        </Typography>
      </Stack>
    </Stack>
  )
}

export default AffiliatedIntermediaryRedirectPage
